module.exports = __webpack_public_path__ + "img/en.38e8aca3.svg";